export default __webpack_public_path__ + "static/media/button-login.min.cf66477b.svg";